import { useCallback, useState } from 'react';

export const useBeautifyResetSignal = (initialSignal = 0) => {
    const [resetSignal, setResetSignal] = useState(initialSignal);

    const resetBeautifyControl = useCallback(() => {
        setResetSignal((current) => current + 1);
    }, []);

    return {
        resetSignal,
        resetBeautifyControl,
    };
};

export default useBeautifyResetSignal;
